import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import PageLayout from '../layout';

import { useStore } from '../store';

import { Ransomware } from './ransomware';
import { SocialMedia } from './socialMedia';
import { PPD } from './ppd';
import { DataLeakage } from './dataLeakage';
import { WhatsApp } from './whatsApp';
import { AiSecurity } from './aiSecurity';
import './hot-topic.less';
import './hot-topic.mobile.less';
import { Button } from 'antd';

interface ICourseProps {}
const HotTopic: React.FunctionComponent<ICourseProps> = (props) => {
  const { language } = useStore();
  const buttonLabel =
    language === 'en' ? 'Complete, back to home' : '完成並回到首頁';
  const param = useParams();
  const [sideCollapsed, setSideCollapsed] = React.useState(
    window.innerWidth <= 1024 ? true : false
  );
  const p_topic = param.topic;
  const { initPageSettings, hotTopics, page } = useStore();
  initPageSettings();

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 1024) {
        setSideCollapsed(true);
      }
    }

    window.addEventListener('resize', handleResize);
    window.addEventListener('click', (e: any) => {
      if (
        window.innerWidth < 1024 &&
        ((e.path &&
          !e?.path?.some(
            (itm: any) =>
              itm.className?.indexOf &&
              itm.className?.indexOf('course-left-side') !== -1
          )) ||
          (!(
            e.target?.parentElement?.className
              ?.toString()
              .indexOf('toggle-menu-icon') !== -1 ||
            e.target?.parentElement?.parentElement?.className
              ?.toString()
              .indexOf('toggle-menu-icon') !== -1
          ) &&
            ![
              'ant-progress-text',
              'course-name',
              'step-dot',
              'course-left-side',
              'course-left-overview',
              'ant-progress-circle-path',
              'ant-progress-circle-trail',
            ].some((itm: any) => e.target.classList.contains(itm)) &&
            !['paragraph'].some((itm: any) =>
              e.target.parentElement.classList.contains(itm)
            )))
      ) {
        setSideCollapsed(true);
      }
    });
  });
  if (!page || !hotTopics || !p_topic) {
    return <div>Loading</div>;
  }
  const course = hotTopics[p_topic];
  const { items } = course;

  if (
    !page?.landing?.HotTopicSections?.some(
      (itm: any) => !itm.hide && itm.page === p_topic
    )
  ) {
    // eslint-disable-next-line no-restricted-globals
    location.href = '/';
    return <div className="pagenotfound">404 Page Not found</div>;
  }

  const backtoHome = () => {
    window.location.href = '/';
  };

  return (
    <PageLayout pageName="course-page" pageClass={p_topic}>
      <div className={`course-body ${sideCollapsed ? 'side-collapsed' : ''}`}>
        {p_topic === 'ransomware' && (
          <Ransomware topicName={p_topic} topicSettings={items} />
        )}
        {p_topic === 'socialMedia' && (
          <SocialMedia topicName={p_topic} topicSettings={items} />
        )}
        {p_topic === 'ppd' && <PPD topicName={p_topic} topicSettings={items} />}
        {p_topic === 'dataLeakage' && (
          <DataLeakage topicName={p_topic} topicSettings={items} />
        )}
        {p_topic === 'whatsApp' && (
          <WhatsApp topicName={p_topic} topicSettings={items} />
        )}
        {p_topic === 'aiSecurity' && (
          <AiSecurity topicName={p_topic} topicSettings={items} />
        )}
        <Button className="next-topic-button" type="text" onClick={backtoHome}>
          <div>{buttonLabel}</div>
        </Button>
      </div>
    </PageLayout>
  );
};

export default HotTopic;
